import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Button, Typography } from '@mui/material';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const useShowErrorDialog = (error) => {
    const [opened, close, open] = useBooleanState(false);
    useEffect(() => {
        if (error != null) {
            open();
        }
    }, [error]);
    const ShowErrorDialog = useMemo(() => {
        const ShowErrorDialogComponent = ({ title, onRepeat, onReject, content, ...rest }) => {
            const _onReject = onReject != null ? onReject : close;
            const _onConfirm = () => {
                onRepeat?.();
                close();
            };
            return (_jsx(MessageBox, { open: opened, onClose: close, isError: true, footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: _onReject, color: "neutral", children: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" }), onRepeat && (_jsx(Button, { color: "error", onClick: _onConfirm, children: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C" }))] }), ...rest, children: content ?? (_jsx(Typography, { variant: "subtitle1", color: "error", sx: { maxWidth: '200px' }, children: error })) }));
        };
        return ShowErrorDialogComponent;
    }, [opened, close]);
    return ShowErrorDialog;
};
